import { useQuery } from '@apollo/client';

import checkUserNewsletterStatus from '../queries/newsletter.graphql';

export const useUserNewsletterStatus = () => {
  return useQuery(checkUserNewsletterStatus);
};
